import { render } from "./TradingViewChart.vue?vue&type=template&id=3e36ff88&scoped=true"
import script from "./TradingViewChart.vue?vue&type=script&lang=js"
export * from "./TradingViewChart.vue?vue&type=script&lang=js"

import "./TradingViewChart.vue?vue&type=style&index=0&id=3e36ff88&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e36ff88"]])

export default __exports__